<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Principal's Message</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">About</a></span>
                                        </div>
                                        <span>Principal's Message</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->

        <!-- teacher details widget start here-->
        <section class="bd-teacher-widget-area pb-70 pt-120">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
                            <div class="bd-teacher-widget-thumb p-relative">
                                <img src="/img/general/principal.png" alt="img not found!" style="height: 478px;">
                                <div class="panel wow"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-50">
                        <div class="bd-teacher-widget theme-bg-6 wow fadeInRight" data-wow-duration="1s"
                            data-wow-delay=".3s">
                            <div class="bd-teacher-widget-content">
                                <h3 class="bd-teacher-widget-title">Yogesh Kuman Sharma</h3>
                                <span class="bd-teacher-widget-tag">Principal, Baburam Vedanta Public School</span>
                                <p>Baburam Vedanta Public School (VGPS) is a pioneer institute run under the aegis of
                                    Vedanta Foundation, with an objective to provide quality education at an affordable
                                    cost to underprivileged students. VGPS is committed to nurture young students and
                                    enable them to become multi-skilled citizens ready to take the dynamic challenges of
                                    life.</p>
                                <p>VGPS provides a state of art infrastructure coupled with a healthy and vibrant
                                    environment conducive to learning. We offer a comprehensive academic curriculum
                                    complemented by a system that encourages each child to be logical, critical, and
                                    analytical in thought and application. Academics is tactfully blended with
                                    co-curricular activities, so that inborn talents of children are brought out and
                                    fostered.</p>
                                <p>VGPS family is proud of numerous milestones achieved by our alumni. Their
                                    achievements continue to motivate and inspire our students to dream big, attain big
                                    and keep replicating the success all through their life. These milestones are being
                                    realized due to the able guidance and firm support of the management, committed &
                                    dedicated teachers and co-operative parents.</p>
                                <p>These collaborative efforts of the VGPS Team is set to be an abiding exercise to
                                    scale greater heights.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
        <!-- teacher details widget end here-->

    </main>
</template>
<script>
export default {
    name: "LeadershipMessageView",
};
</script>
